@if (modo === 'timeline') {
  <!-- ===== HISTÓRICO — timeline (coluna esquerda) ===== -->
  <div class="section-title">
    <mat-icon>history</mat-icon>
    <span>Histórico</span>
    @if (!carregando) {
      <span class="status-badge badge-cinza">{{ history.length }}</span>
    }
  </div>

  @if (carregando) {
    <app-loading-box height="48" width="100%" marginTop="0"></app-loading-box>
    <app-loading-box height="48" width="100%" marginTop="12"></app-loading-box>
    <app-loading-box height="48" width="100%" marginTop="12"></app-loading-box>
  } @else {
    <app-timeline-historico
      [itens]="history"
      [exibirFiltros]="true"
      [permiteDetalhes]="true"
      [permiteAnotacao]="permiteAnotacao"
      [registrandoAnotacao]="registrandoAnotacao"
      (detalhar)="onDetalhar($event)"
      (registrarAnotacao)="registrarAnotacao.emit($event)"></app-timeline-historico>
  }
} @else if (selectedItem) {
  <!-- ===== HISTÓRICO — detalhe da ocorrência (coluna direita) ===== -->
  <div class="ced-col-right">
    <div class="ced-col-right-head">
      <div class="ced-col-right-title">
        <mat-icon class="material-symbols-outlined ced-col-right-ico">history</mat-icon>
        {{ (selectedItem.alteracoes && selectedItem.alteracoes.length) ? 'Detalhes da alteração' : 'Detalhes da ocorrência' }}
      </div>
      <button type="button" class="ced-head-icon" (click)="fechar.emit()" matTooltip="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
    <div class="ced-col-right-meta">
      <div class="ced-tl-who">
        <span class="ced-avatar" [style.background]="corAvatar(selectedItem.quemNome)">{{ iniciais(selectedItem.quemNome) }}</span>
        <b>{{ selectedItem.quemNome }}</b>
        <span class="ced-tl-when">{{ selectedItem.quando | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <div class="ced-tl-text ced-tl-titulo">{{ selectedItem.titulo }}</div>
      @if (selectedItem.descricao) {
        <div class="ced-tl-text">{{ selectedItem.descricao }}</div>
      }
    </div>
    <div class="ced-col-right-body">
      @if (selectedItem.justificativa) {
        <div class="ced-just-detail">
          <div class="ced-just-detail-label">Justificativa</div>
          <div class="ced-just-detail-text">{{ selectedItem.justificativa }}</div>
        </div>
      }
      @if (selectedItem.notificacao) {
        @if (selectedItem.notificacao.faixa) {
          <div class="ced-just-detail">
            <div class="ced-just-detail-label">Faixa aplicada</div>
            <div class="ced-just-detail-text">{{ selectedItem.notificacao.faixa }}</div>
          </div>
        }
        <div class="ced-just-detail">
          <div class="ced-just-detail-label">{{ resumoNotificados(selectedItem.notificacao.nomes.length) }}</div>
          @for (nome of selectedItem.notificacao.nomes; track $index) {
            <div class="ced-notificado">
              <mat-icon class="material-symbols-outlined">person</mat-icon>
              <span>{{ nome }}</span>
            </div>
          }
        </div>
      }
      @if (selectedItem.compras && selectedItem.compras.length) {
        <div class="ced-just-detail">
          <div class="ced-just-detail-label">Compras</div>
          <div class="ced-tl-compras">
            @for (compra of selectedItem.compras; track compra.idCompra) {
              <button type="button" class="ced-tl-compra-link" (click)="abrirCompra.emit(compra)">
                {{ codigoCompra(compra) }}
              </button>
            }
          </div>
        </div>
      }
      @for (ch of selectedItem.alteracoes; track $index) {
        <div class="ced-chg">
          <span class="ced-chg-field">
            @if (ch.item) { <span class="ced-chg-item">{{ ch.item }}</span> · }{{ ch.label }}
          </span>
          <span class="ced-chg-vals">
            @if (ch.acao === 'adicionado') {
              <span class="ced-chg-new">{{ ch.para }}</span>
            } @else if (ch.acao === 'removido') {
              <span class="ced-chg-old">{{ ch.de }}</span>
            } @else {
              <span class="ced-chg-old">{{ ch.de }}</span>
              <mat-icon class="material-symbols-outlined ced-chg-arrow">arrow_forward</mat-icon>
              <span class="ced-chg-new">{{ ch.para }}</span>
            }
          </span>
        </div>
      }
    </div>
  </div>
}
